<template>
  <div class="languages-switcher" v-if="localesLoaded">
    <span>{{ internalValue }}</span>
    <i class="icon icon-icon_arrow-down"></i>
    <ul>
      <li v-for="client in locales" v-bind:class="{ 'active': client.id == value }" :rel="client.id">
        <span @click="switchToLocale(client.id)"><img :src="'/src/assets/flags/'+client.id+'.svg'"/></span>
      </li>
      <li v-bind:class="{ 'active': 'all' == value }">
        <span @click="switchToLocale('all')">all</span>
      </li>
    </ul>
  </div>
</template>

<script>
    export default {
        name: 'switch',
        props: ['value','localesLoaded','locale','locales'],
        data() {
            return {
            }
        },
        created: function(){
            this.internalValue = this.value;
        },
        methods: {
            switchToLocale: function(locale){
                this.internalValue = locale;
                this.$emit('input', this.internalValue);
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Languages.vue